export default __webpack_public_path__ + "static/media/placeholder_dummy2016-asia-restaurant01-mobile-de.65f23daa.png";